export default "__VITE_ASSET__Clth7JAv__"